<div *ngIf="client">


  <div class="global-block-title" *ngIf="client?.discounts.length">Акции и скидки</div>
<!--  <div class="discount-wrapper">-->
<!--    <div class="item" *ngFor="let discount of client?.discounts; let i = index"-->
<!--    >-->
<!--      <div class="name">{{discount?.comment}}</div>-->
<!--      <div class="till">До: {{discount?.till | momentDate}}</div>-->
<!--    </div>-->
<!--  </div>-->
  <div>
    <owl-carousel-o [options]="customOptions" [class.single-item]="client?.discounts?.length === 1">
      <ng-container *ngFor="let discount of client.discounts; let i = index">
        <ng-template carouselSlide [id]="'zzz'">
          <div class="discount-item-wrapper" [class.discount-red]="i % 2 == 0" [class.discount-blue]="i % 2 == 1">
            <div class="name">{{discount.comment}}</div>
            <div class="till">До: {{discount.till | momentDate}}</div>
          </div>
        </ng-template>
      </ng-container>

    </owl-carousel-o>
  </div>



  <div class="global-block-title">Мои данные</div>
  <div class="user-info">
    <div class="user-info-item">
      <span class="user-info-title">Дата Рождения:</span>
      <div class="user-info-data">{{client.birthday | momentDate}}</div>
    </div>
    <div class="user-info-item">
      <span class="user-info-title">E-mail:</span>
      <div class="user-info-data">
        <a href="mailto: {{client.email}}" *ngIf="client.email">{{client.email}}</a>
        <ng-template ngIf [ngIf]="!client.email">&mdash;</ng-template>
      </div>
    </div>
    <div class="user-info-item">
      <span class="user-info-title">Телефон:</span>
      <div class="user-info-data">{{client.phone}}</div>
    </div>
    <div class="user-info-item">
      <span class="user-info-title">Город:</span>
      <div class="user-info-data">{{client.city || '&mdash;'}}</div>
    </div>


    <div class="profile-btn">

      <button class="button blue-btn password-btn"(click)="openPasswordPopup()" >
        Сменить пароль
      </button>
    </div>

  </div>

  <div class="global-block-title" >Связанные лица</div>
  <table class="table noborder" *ngIf="client?.members?.length">
    <tr>
      <th class='min-screen mid-screen'>ФИО</th>
      <th class='max-screen'>Имя</th>
      <th class='max-screen'>Отчество</th>
      <th class='max-screen'>Фамилия</th>
<!--      <th class='max-screen mid-screen'>Категория</th>-->
      <th class='max-screen mid-screen'>Дата Рождения</th>
      <th class='max-screen'>E-mail</th>
      <th class='max-screen'>Телефон</th>
      <th class='mid-screen'>Контакты</th>

    </tr>
    <tbody>
    <tr class="border_bottom" *ngFor="let user of client?.members; let i = index">
      <td class='max-screen'>
        <div class="first-name">{{user.firstName}}</div>
      </td>
      <td class='max-screen'>
        <div class="last-name">{{user.secondName}}</div>
      </td>
      <td class='max-screen'>
        <div class="last-name">{{user.lastName}}</div>
      </td>
      <td class='mid-screen'>{{user.firstName}} {{user.secondName}} {{user.lastName}}</td>

<!--      <td class='max-screen mid-screen'>-->
<!--        <div class="email-wrapper">{{user.ageType?.text}}</div>-->
<!--      </td>-->
      <td class='max-screen mid-screen'>
        <div class="email-wrapper">{{user.birthday | momentDate}}</div>
      </td>
      <td class='max-screen'>
        <div class="email-wrapper">{{user.email}}</div>
      </td>
      <td class='max-screen'>
        <div class="phone">{{user.phone}}</div>
      </td>
      <td class='mid-screen'>
        <div class="email-wrapper">{{user.email}}</div>
        <div class="phone">{{user.phone}}</div>
      </td>


      <td class='min-screen'>
        <div class="first-last-name">{{user.firstName}} {{user.secondName}} {{user.lastName}}</div>
        <div class="email-wrapper font-gray">{{user.birthday | momentDate}}</div>
        <div class="email-wrapper font-gray">{{user.email}}</div>
        <div class="email-wrapper font-gray">{{user.phone}}</div>
        <div class="first-last-name">{{user.comment}}</div>
      </td>



<!--      <td class="actions">-->
<!--        <div class="actions-block">-->
<!--          <span class="lnr lnr-pencil in-circle" (click)="openEditMemberPopup(user, i)"></span>-->
<!--          <span class="lnr lnr-trash in-circle" (click)="deleteMember(user, i)"></span>-->
<!--        </div>-->
<!--      </td>-->
    </tr>
    </tbody>
  </table>
  <div class="no-data-notification" *ngIf="!client?.members?.length">
    У вас нет связанных лиц
  </div>
<!--  <div class="btn-add-row" (click)="openEditMemberPopup()">-->
<!--    <span class="plus-icon"></span>-->
<!--    Добавить связанное лицо-->
<!--  </div>-->

</div>


<!--<app-member-popup *ngIf="member" [client]="client" [member]="member.data" [index]="member.index"-->
<!--                  (notify)="onNotify($event)"></app-member-popup>-->

<app-edit-password-popup *ngIf="showPasswordPopup"
                         (notify)="onNotify($event)"></app-edit-password-popup>


<!--<app-client-popup *ngIf="showEditClient" [client]="client" (notify)="onNotify($event)"></app-client-popup>-->

<!--<app-client-discount-popup *ngIf="discount" [discount]="discount.data" [index]="discount.index" [clientId]="client?.id"-->
<!--                           (notify)="onNotify($event)">-->
<!--</app-client-discount-popup>-->
<!--<app-confirm *ngIf="confirm" [data]="confirm" (notify)="onConfirmNotify($event)"></app-confirm>-->

<!--<div class="action-block" (click)="openEditPopup()">-->
<!--  <span class="lnr lnr-pencil "></span>-->
<!--</div>-->
